import {
  LoadingButtonProps,
  LoadingButton as MuiLoadingButton,
} from "@mui/lab";
import {styled} from "@mui/material";
// import Loading from "../Loading";

const LoadingButton = styled(MuiLoadingButton)(({theme, size, allrounded = true}: LoadingButtonProps & {
  allrounded: boolean,
  theme
}) => {
  let height = 42
  let rounded = "12px";
  let fontSize = "16px";
  let padding = "4px 12px";

  if (size === 'large') {
    height = 47;
    rounded = "2px";
  } else if (size === 'small') {
    height = 36;
    rounded = "2px";
  }
  if (allrounded) {
    // height = 26;
    rounded = `${height / 2}px`;
    // fontSize = "14px";
  }

  return {
    height,
    fontWeight: 500,
    lineHeight: 1,
    borderRadius: rounded,
    color: theme === "dark" ? theme.palette.white : theme.palette.black,
    fontSize,
    padding,
    boxShadow: "none"
  };
});

export default function AppLoadingButton(
  props: Omit<LoadingButtonProps, "loadingPosition" | "loadingIndicator"> & { allrounded?: boolean }
) {
  let _loadingButtonProps = {}
  if (props.startIcon) {
    _loadingButtonProps = { loadingPosition: 'start' }
  }
  return (
    <LoadingButton
      {...props}
      // loadingPosition={props.startIcon ? 'start' : ''}
      {..._loadingButtonProps}
      startIcon={props.startIcon ?? ""}
      size={props?.size ? props?.size : 'large'}
      // loadingIndicator={<Loading  size={18}/>}
    >
      <span style={{background: "red!important"}}>{props.children}</span>
    </LoadingButton>
  );
}
